import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/pro-regular-svg-icons/faFileLines";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

interface Props {
  element: DocumentElementType;
}

/**
 * Read-only render of a page-document "link a page" block — an icon + title row
 * rendered from the stored snapshot (`data.title` / `data.icon`). The editor's
 * live-title / navigating version lives in apps/web; this static card is what a
 * PDF / portal shows.
 */
const PageLinkView: React.FC<Props> = ({ element }) => {
  const data = (element.data ?? {}) as {
    pageUid?: string;
    title?: string;
    icon?: string;
  };
  if (!data.pageUid && !data.title) return null;

  const title = data.title || "Untitled";
  const icon = data.icon;

  return (
    <div className="flex items-center gap-[10px] rounded-[10px] border border-[#e7e5e1] bg-white px-[14px] py-[10px]">
      {icon ? (
        <span className="flex-none text-[16px] leading-none">{icon}</span>
      ) : (
        <FontAwesomeIcon
          icon={faFileLines}
          className="flex-none text-[14px] text-[#8f8b83]"
        />
      )}
      <span className="min-w-0 flex-1 truncate font-jakarta text-[13.5px] font-semibold text-[#2a2723] underline decoration-[#d8d5cf] underline-offset-[3px]">
        {title}
      </span>
      <FontAwesomeIcon
        icon={faArrowUpRightFromSquare}
        className="flex-none text-[11px] text-[#b4b0a8]"
      />
    </div>
  );
};

export default PageLinkView;
